var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplatelist1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.04,
    height: 31.234,
    viewBox: "0 0 23.04 31.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50132",
    "data-name": "Group 50132",
    transform: "translate(-142.28 -42.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93927",
    "data-name": "Path 93927",
    d: "M143.148,42.32h14.364a.865.865,0,0,1,.633.274l6.936,6.937a.862.862,0,0,1,.238.576V72.687a.868.868,0,0,1-.868.868h-21.3a.868.868,0,0,1-.868-.868v-29.5A.868.868,0,0,1,143.148,42.32Zm9.079,21.691a.868.868,0,0,1,0-1.735h9.166a.868.868,0,0,1,0,1.735Zm-6.02,0a.868.868,0,0,1,0-1.735h2.873a.868.868,0,0,1,0,1.735Zm6.02-3.471a.868.868,0,0,1,0-1.735h9.166a.868.868,0,0,1,0,1.735Zm-6.02,0a.868.868,0,0,1,0-1.735h2.873a.868.868,0,0,1,0,1.735Zm6.02-3.471a.868.868,0,0,1,0-1.735h9.166a.868.868,0,0,1,0,1.735Zm-6.02,0a.868.868,0,0,1,0-1.735h2.873a.868.868,0,0,1,0,1.735Zm6.02-3.471a.868.868,0,0,1,0-1.735h9.166a.868.868,0,0,1,0,1.735Zm-6.02,0a.868.868,0,0,1,0-1.735h2.873a.868.868,0,0,1,0,1.735ZM163.584,51h-6.072a.868.868,0,0,1-.868-.868V44.055H144.016V71.819h19.569Zm-5.2-5.713v3.979h3.978Z",
    fill: "#0c66e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatelist1);
export default __webpack_public_path__ + "static/media/templatelist1.cc9ac7243cff30e7527689c2d5b59858.svg";
export { ForwardRef as ReactComponent };